import { LifeInsurance } from '@/app/life-insurance/entities/life-insurance.entity'

export interface LifeInsuranceState {
    lifeInsurances: LifeInsurance[]
}

export const state: LifeInsuranceState = {
    lifeInsurances: []
}
